/* eslint-disable import/no-default-export */
import { mallApiDomain } from '@/defines/domains'
import { request } from '../request'

export const mallTradeApi = {
  async post(path, data) {
    try {
      const url = `${mallApiDomain}/mall_trade/api${path}`
      const res = await request(url, data)
      if (res.ret) {
        return res.data
      } else {
        return Promise.reject(res)
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
